import { AccountsUserIdFollowPostInputModel } from "../../api/v2/accounts/[user_id]/follow/PostInputModel"
import { postAccountsUserIdFollow } from "../../api/v2/accounts/[user_id]/follow/post"

export const followCreator = (userId: string): Promise<void> => {
  const model = new AccountsUserIdFollowPostInputModel({ userId })

  return postAccountsUserIdFollow(model)
}
